import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  ar: {
    // Navigation
    home: 'الرئيسية',
    about: 'من نحن',
    products: 'منتجاتنا',
    contracts: 'الشراكات والعقود',
    contact: 'تواصل معنا',
    
    // Hero Section
    heroTitle: 'البصمة الحديثة لاستيراد المعدات الطبية ومستلزمات الأم والطفل',
    heroSubtitle: 'شريكك الموثوق لاستيراد وتوريد المعدات الطبية ومستلزمات الأم والطفل عالية الجودة في ليبيا',
    heroDesc: 'نوفر أحدث الأجهزة الطبية والمستلزمات الصحية ومستلزمات الأم والطفل للمستشفيات والعيادات والصيدليات وشركات الجملة',
    learnMore: 'تواصل معنا',
    viewProducts: 'منتجاتنا',
    
    // Features
    featuresTitle: 'لماذا البصمة الحديثة لاستيراد المعدات الطبية؟',
    feature1Title: 'جودة طبية موثوقة',
    feature1Desc: 'نستورد فقط من أفضل العلامات التجارية العالمية المعتمدة',
    feature2Title: 'تجهيزات حديثة',
    feature2Desc: 'أحدث التقنيات والأجهزة الطبية المتطورة',
    feature3Title: 'خدمة سريعة',
    feature3Desc: 'توصيل مجاني داخل طرابلس مع خدمة عملاء متميزة',
    
    // Wholesale Services
    wholesaleTitle: 'خدمات الجملة',
    wholesaleSubtitle: 'شريكك في توريد المعدات الطبية بالجملة',
    wholesaleDesc: 'نقدم خدمات التوريد بالجملة لشركات المعدات الطبية ومستلزمات الأم والطفل',
    wholesaleFeature1: 'أسعار تنافسية للكميات الكبيرة',
    wholesaleFeature2: 'تشكيلة واسعة من المنتجات',
    wholesaleFeature3: 'دعم فني متواصل',
    wholesaleFeature4: 'توصيل لجميع أنحاء ليبيا',
    
    // Products Section
    productsTitle: 'منتجاتنا',
    productsSubtitle: 'تشكيلة واسعة من المعدات الطبية عالية الجودة',
    viewAll: 'عرض الكل',
    
    // Categories
    catMotherBaby: 'مستلزمات الأم والطفل',
    catMedicalDevices: 'الأجهزة الطبية',
    catOrthopedic: 'الأحزمة والدعامات الطبية',
    catChairs: 'الكراسي الطبية',
    catSupplies: 'المستلزمات الطبية',
    
    // About Page
    aboutTitle: 'من نحن',
    aboutSubtitle: 'قصة البصمة الحديثة لاستيراد المعدات الطبية',
    aboutIntro: 'البصمة الحديثة لاستيراد المعدات الطبية ومستلزمات الأم والطفل هي شركة ليبية رائدة في مجال استيراد وتوزيع المعدات والمستلزمات الطبية ومستلزمات الأم والطفل. نعمل منذ سنوات على تزويد القطاع الصحي في ليبيا بأحدث التقنيات والأجهزة الطبية من أشهر العلامات التجارية العالمية.',
    visionTitle: 'رؤيتنا',
    visionDesc: 'أن نكون الشريك الأول والأكثر ثقة في مجال المعدات الطبية في ليبيا، ونساهم في تطوير القطاع الصحي من خلال توفير أحدث التقنيات والحلول الطبية.',
    missionTitle: 'مهمتنا',
    missionDesc: 'توفير معدات طبية عالية الجودة بأسعار تنافسية، مع خدمة عملاء متميزة ودعم فني متكامل للمستشفيات والعيادات والصيدليات وشركات الجملة.',
    experienceTitle: 'خبرتنا',
    experienceDesc: 'نفتخر بتعاوننا مع كبرى المستشفيات والعيادات والصيدليات وشركات الجملة في طرابلس وليبيا، ونسعى دائماً لتقديم أفضل الحلول الطبية.',
    
    // Contracts Page
    contractsTitle: 'الشراكات والعقود',
    contractsSubtitle: 'نوفر عقود توريد متكاملة للقطاع الصحي',
    contractsIntro: 'نقدم عقود توريد شاملة ومرنة تناسب احتياجات:',
    hospitals: 'المستشفيات',
    clinics: 'العيادات',
    pharmacies: 'الصيدليات',
    medicalCenters: 'المراكز الطبية',
    wholesaleCompanies: 'شركات الجملة',
    motherBabyStores: 'محلات مستلزمات الأم والطفل',
    requestContract: 'طلب عقد توريد',
    
    // Contact Page
    contactTitle: 'تواصل معنا',
    contactSubtitle: 'نحن هنا للإجابة على استفساراتك',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    address: 'العنوان',
    addressValue: 'ليبيا - طرابلس - طريق الشوك',
    freeDelivery: 'توصيل مجاني داخل طرابلس',
    
    // Form Fields
    name: 'الاسم',
    companyName: 'اسم الشركة',
    phoneNumber: 'رقم الهاتف',
    emailAddress: 'البريد الإلكتروني',
    message: 'الرسالة',
    send: 'إرسال',
    sendRequest: 'إرسال الطلب',
    
    // Footer
    quickLinks: 'روابط سريعة',
    contactInfo: 'معلومات التواصل',
    copyright: '© 2025 البصمة الحديثة لاستيراد المعدات الطبية ومستلزمات الأم والطفل. جميع الحقوق محفوظة.',
    
    // Brands
    ourPartners: 'شركاؤنا من العلامات التجارية العالمية',
    trustedBrands: 'نتعامل مع أفضل العلامات التجارية الطبية العالمية',
  },
  en: {
    // Navigation
    home: 'Home',
    about: 'About Us',
    products: 'Products',
    contracts: 'Partnerships',
    contact: 'Contact',
    
    // Hero Section
    heroTitle: 'ALBASMA ALHADITHA Medical Equipment',
    heroSubtitle: 'Your trusted partner for importing high-quality medical equipment in Libya',
    heroDesc: 'We provide the latest medical devices and healthcare supplies for hospitals, clinics, and pharmacies',
    learnMore: 'Learn More',
    viewProducts: 'View Products',
    
    // Features
    featuresTitle: 'Why ALBASMA ALHADITHA?',
    feature1Title: 'Certified Quality',
    feature1Desc: 'We import only from the best certified global brands',
    feature2Title: 'Modern Equipment',
    feature2Desc: 'Latest technologies and advanced medical devices',
    feature3Title: 'Fast Service',
    feature3Desc: 'Free delivery in Tripoli with excellent customer service',
    
    // Products Section
    productsTitle: 'Our Products',
    productsSubtitle: 'Wide range of high-quality medical equipment',
    viewAll: 'View All',
    
    // Categories
    catMotherBaby: 'Mother & Baby',
    catMedicalDevices: 'Medical Devices',
    catOrthopedic: 'Orthopedic Supports',
    catChairs: 'Medical Chairs',
    catSupplies: 'Medical Supplies',
    
    // About Page
    aboutTitle: 'About Us',
    aboutSubtitle: 'The ALBASMA ALHADITHA Story',
    aboutIntro: 'ALBASMA ALHADITHA is a leading Libyan company specializing in importing and distributing medical equipment and supplies. We have been providing the healthcare sector in Libya with the latest technologies and medical devices from world-renowned brands.',
    visionTitle: 'Our Vision',
    visionDesc: 'To be the first and most trusted partner in medical equipment in Libya, contributing to the development of the healthcare sector by providing the latest technologies and medical solutions.',
    missionTitle: 'Our Mission',
    missionDesc: 'Providing high-quality medical equipment at competitive prices, with excellent customer service and comprehensive technical support for hospitals, clinics, and pharmacies.',
    experienceTitle: 'Our Experience',
    experienceDesc: 'We are proud of our collaboration with major hospitals, clinics, and pharmacies in Tripoli and Libya, always striving to provide the best medical solutions.',
    
    // Contracts Page
    contractsTitle: 'Partnerships & Contracts',
    contractsSubtitle: 'We provide comprehensive supply contracts for the healthcare sector',
    contractsIntro: 'We offer comprehensive and flexible supply contracts to meet the needs of:',
    hospitals: 'Hospitals',
    clinics: 'Clinics',
    pharmacies: 'Pharmacies',
    medicalCenters: 'Medical Centers',
    requestContract: 'Request a Contract',
    
    // Contact Page
    contactTitle: 'Contact Us',
    contactSubtitle: 'We are here to answer your inquiries',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    addressValue: 'Libya - Tripoli - Tariq Al-Shawk',
    freeDelivery: 'Free delivery in Tripoli',
    
    // Form Fields
    name: 'Name',
    companyName: 'Company Name',
    phoneNumber: 'Phone Number',
    emailAddress: 'Email Address',
    message: 'Message',
    send: 'Send',
    sendRequest: 'Send Request',
    
    // Footer
    quickLinks: 'Quick Links',
    contactInfo: 'Contact Info',
    copyright: '© 2025 ALBASMA ALHADITHA. All rights reserved.',
    
    // Brands
    ourPartners: 'Our Global Brand Partners',
    trustedBrands: 'We work with the best global medical brands',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ar');
  const [direction, setDirection] = useState('rtl');

  useEffect(() => {
    const savedLang = localStorage.getItem('language') || 'ar';
    setLanguage(savedLang);
    setDirection(savedLang === 'ar' ? 'rtl' : 'ltr');
  }, []);

  const toggleLanguage = () => {
    const newLang = language === 'ar' ? 'en' : 'ar';
    setLanguage(newLang);
    setDirection(newLang === 'ar' ? 'rtl' : 'ltr');
    localStorage.setItem('language', newLang);
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  const value = {
    language,
    direction,
    toggleLanguage,
    t,
    isArabic: language === 'ar'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
